import { createContext, useContext, type ReactNode } from 'react';
import { Button } from '@shopify/polaris';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../app/stores/store';
import { useLegacyMode } from '../legacy/LegacyModeContext';
import { getPlanFeaturePresentation, PLAN_FEATURES, type PlanFeature } from './planPresentation';
import './PlanFeatureStatus.css';

const PlanNavigationContext = createContext<(() => void) | undefined>(undefined);
export const PlanNavigationProvider = ({ onViewPlans, children }: { onViewPlans: () => void; children: ReactNode }) => (
    <PlanNavigationContext.Provider value={onViewPlans}>{children}</PlanNavigationContext.Provider>
);

// Presentation only: never wraps, hides, disables, or changes the feature's controls.
const PlanFeatureStatus = ({ feature }: { feature: PlanFeature }) => {
    const store = useStore();
    const legacy = useLegacyMode();
    const retainedLegacyAccess = !!(legacy?.isLegacy || legacy?.status?.legacySourceShopId || legacy?.status?.legacyDataMigratedAt);
    const presentation = getPlanFeaturePresentation(feature, store?.userStore?.user?.subscription, retainedLegacyAccess);
    const onViewPlans = useContext(PlanNavigationContext);
    // Routine features and retained access need no plan chrome or reserved space.
    if (presentation.state !== 'upgrade') return null;

    return <div className="pf-plan-feature" role="group" aria-label={`${PLAN_FEATURES[feature].label} plan availability`}>
        <Button variant="plain" size="slim" accessibilityLabel={`Upgrade to unlock with ${presentation.tierLabel}`}
            onClick={onViewPlans} url={onViewPlans ? undefined : '/plan'}>Upgrade to unlock</Button>
    </div>;
};

export default observer(PlanFeatureStatus);
